<template>
  <div :class="topClass">
    SIO
    <div :class="className">
      <div class="flex-row items-center">
        <input
          type="radio"
          value="1"
          v-model="chooseSio"
          style="margin-right: 10px"
        />
        <div>Aktif</div>
      </div>
      <div class="flex-row items-center">
        <input
          type="radio"
          value="0"
          v-model="chooseSio"
          style="margin-right: 10px"
        />
        <div>Tidak Aktif</div>
      </div>
      <div class="btn-filter-clear" @click="clearChoosed">
        <i class="fa-solid fa-xmark"></i>
        Clear
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['className', 'topClass'],
  computed: {
    chooseSio: {
      get: function() {
        return this.$store.state.searchStore.chooseSio
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'chooseSio',
          value: newValue,
        })
      },
    },
  },
  methods: {
    clearChoosed() {
      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'chooseSio',
        value: null,
      })
    },
  },
}
</script>
